type Affiliate = {
  referrer: string;
  applicationPath: string;
  callback?: () => void;
};

/**
 * Builds the redirect URL with UTM parameters.
 * Uses "::" as a separator for utm_source and utm_campaign.
 * Everything is just URL encoded - no fancy mapping.
 */
export function buildRedirectUrl(affiliate: Affiliate): string {
  const baseUrl = affiliate.applicationPath;

  // Check if referrer contains "::" (ambassador or multi-part referrer)
  if (affiliate.referrer.includes("::")) {
    const [source, campaign] = affiliate.referrer.split("::");
    return `${baseUrl}?utm_source=${encodeURIComponent(source)}&utm_campaign=${encodeURIComponent(campaign)}&utm_medium=affiliate`;
  }

  // Regular affiliate - just URL encode the referrer string
  return `${baseUrl}?utm_source=${encodeURIComponent(affiliate.referrer)}&utm_medium=affiliate`;
}

const affiliates = new Map<string, Affiliate>();

affiliates.set("/virginia-spouses", {
  referrer: "Virginia DVS",
  applicationPath: "/protege-spouse",
});

affiliates.set("/virginia-spouse", {
  referrer: "Virginia DVS",
  applicationPath: "/protege-spouse",
});

affiliates.set("/virginia", {
  referrer: "Virginia DVS",
  applicationPath: "/protege",
});

affiliates.set("/vre", {
  referrer: "VR&E",
  applicationPath: "/protege",
});

affiliates.set("/vrespouse", {
  referrer: "VR&E",
  applicationPath: "/protege-spouse",
});

affiliates.set("/bsf", {
  referrer: "BSF",
  applicationPath: "/protege-spouse",
});

affiliates.set("/recruitmilitary", {
  referrer: "RecruitMilitary",
  applicationPath: "/protege",
});

affiliates.set("/recruitmilitary-spouses", {
  referrer: "RecruitMilitary",
  applicationPath: "/protege-spouse",
});

affiliates.set("/therosienetwork", {
  referrer: "The Rosie Network",
  applicationPath: "/protege",
});

affiliates.set("/therosienetwork-spouses", {
  referrer: "The Rosie Network",
  applicationPath: "/protege-spouse",
});

affiliates.set("/warrior-rising", {
  referrer: "Warrior Rising",
  applicationPath: "/protege",
});

affiliates.set("/warrior-rising-spouses", {
  referrer: "Warrior Rising",
  applicationPath: "/protege-spouse",
});

affiliates.set("/ibx", {
  referrer: "IBX",
  applicationPath: "/protege",
});

affiliates.set("/acp-champion-spouses", {
  referrer: "ACP Champion",
  applicationPath: "/protege-spouse",
});

affiliates.set("/acp-champion", {
  referrer: "ACP Champion",
  applicationPath: "/protege",
});

affiliates.set("/ptsdusa", {
  referrer: "PTSD USA",
  applicationPath: "/protege",
});

affiliates.set("/ptsdusa-spouses", {
  referrer: "PTSD USA",
  applicationPath: "/protege-spouse",
});

affiliates.set("/hrvec", {
  referrer: "HamptonRoadsVEC",
  applicationPath: "/protege",
});

affiliates.set("/ivmf", {
  referrer: "O2O",
  applicationPath: "/protege",
});

affiliates.set("/ivmf-spouses", {
  referrer: "O2O",
  applicationPath: "/protege-spouse",
});

affiliates.set("/invets", {
  referrer: "INvets",
  applicationPath: "/protege",
});

affiliates.set("/invets-spouses", {
  referrer: "INvets",
  applicationPath: "/protege-spouse",
});

affiliates.set("/bmr", {
  referrer: "Bridge My Return",
  applicationPath: "/protege",
});

affiliates.set("/linkedin", {
  referrer: "LinkedIn",
  applicationPath: "/mentor/acpusa",
});

affiliates.set("/lmh", {
  referrer: "LibertyHousing",
  applicationPath: "/protege"
});

affiliates.set("/lmh-spouses", {
  referrer: "LibertyHousing",
  applicationPath: "/protege-spouse"
});

affiliates.set("/msan", {
  referrer: "MSAN",
  applicationPath: "/protege-spouse",
});

affiliates.set("/tenova", {
  referrer: "Tenova",
  applicationPath: "/protege",
});

affiliates.set('/tenova-spouses', {
  referrer: "Tenova",
  applicationPath: "/protege-spouse"
});

affiliates.set("/major-talent", {
  referrer: "Major Talent",
  applicationPath: "/protege",
});

affiliates.set("/major-talent-spouses", {
  referrer: "Major Talent",
  applicationPath: "/protege-spouse",
});

affiliates.set("/usaa", {
  referrer: "USAA",
  applicationPath: "/protege",
});

affiliates.set("/usaa-spouses", {
  referrer: "USAA",
  applicationPath: "/protege-spouse",
});

affiliates.set("/uso", {
  referrer: "USO",
  applicationPath: "/protege",
});

affiliates.set("/uso-spouses", {
  referrer: "USO",
  applicationPath: "/protege-spouse",
});

affiliates.set("/hkpo", {
  referrer: "HKPO",
  applicationPath: "/protege",
});

affiliates.set("/hkpo-spouses", {
  referrer: "HKPO",
  applicationPath: "/protege-spouse"
});

affiliates.set("/dvmf", {
  referrer: "Maryland DVMF",
  applicationPath: "/protege"
});

affiliates.set("/dvmf-spouses", {
  referrer: "Maryland DVMF",
  applicationPath: "/protege-spouse"
})

affiliates.set("/hoh", {
  referrer: "HOH",
  applicationPath: "/protege",
});

affiliates.set("/hoh-spouses", {
  referrer: "HOH",
  applicationPath: "/protege-spouse",
});

// AMBASSADORS

affiliates.set("/akulesza", {
  referrer: "Ambassador::Amber Kulesza",
  applicationPath: "/protege"
});

affiliates.set("/atolver", {
  referrer: "Ambassador::Alecia Tolver",
  applicationPath: "/protege",
});

affiliates.set("/gcurnutt", {
  referrer: "Ambassador::Gisselle Hassan-Curnutt",
  applicationPath: "/protege",
});

affiliates.set("/jsinclair", {
  referrer: "Ambassador::Jen Sinclair",
  applicationPath: "/protege",
});

affiliates.set("/jchaires", {
  referrer: "Ambassador::Jozue Chaires",
  applicationPath: "/protege",
});

affiliates.set("/kkelly", {
  referrer: "Ambassador::Kasey Kelly",
  applicationPath: "/protege",
});

affiliates.set("/npg", {
  referrer: "Ambassador::Nicole Pallai Green",
  applicationPath: "/protege",
});

affiliates.set("/ringram", {
  referrer: "Ambassador::Rae Ingram",
  applicationPath: "/protege",
});

affiliates.set("/rkaplan", {
  referrer: "Ambassador::Rich Kaplan",
  applicationPath: "/protege",
});

affiliates.set("/shebing", {
  referrer: "Ambassador::Shelby Hebing",
  applicationPath: "/protege",
});

//END AMBASSADORS

// MENTOR REFERRALS
affiliates.set("/from/boa", {
  referrer: "Bank of America",
  applicationPath: "/mentor/acpusa",
});

affiliates.set("/from/disney", {
  referrer: "Disney",
  applicationPath: "/mentor/ACPUSA",
});

affiliates.set("/from/travelers", {
  referrer: "Travelers",
  applicationPath: "/mentor/ACPUSA",
});

affiliates.set("/from/invets", {
  referrer: "INvets",
  applicationPath: "/mentor/ACPUSA"
});

affiliates.set("/from/dvmf", {
  referrer: "Maryland DVMF",
  applicationPath: "/mentor/ACPUSA"
})

export default affiliates;
